import styled from "styled-components";

export const Container = styled.div`
	ul {
		list-style-type: "- ";
		padding-left: 7px;
	}

	h4,
	h5 {
		font-weight: bold;
	}

	p {
		margin-top: 2rem;
		margin-bottom: 3rem;
	}
`;
export const TitlePart = styled.div`
	font-size: 1rem;
	text-align: center;

	margin: 0.5rem 0;
`;

export const ItemListDetails = styled.li`
	color: #878e95;
`;

export const FooterModal = styled.div`
	width: 100%;

	> button {
		max-width: 100%;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
		display: none;
	}
`;
